import { parse as parseAri } from '@atlassian/cs-ari';
export const getCloudIdFromHostInfo = hostInfo => {
  if (hostInfo) {
    return parseAri(hostInfo.globalContext.id).cloudId;
  }
};